(() => {
  const initK9Experience = () => {
    const hero = document.querySelector('[data-k9-hero]');
    const product = document.querySelector('.aqua-k9-product');
    const rail = document.querySelector('[data-k9-purchase-rail]');

    if (hero && !hero.dataset.k9MotionReady) {
      hero.dataset.k9MotionReady = 'true';
      const productImage = hero.querySelector('[data-k9-parallax-product]');
      const canUsePointerMotion = window.matchMedia(
        '(min-width: 990px) and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)'
      );
      let frame;

      const resetMotion = () => {
        [productImage].forEach((element) => {
          if (!element) return;
          element.style.removeProperty('--k9-parallax-x');
          element.style.removeProperty('--k9-parallax-y');
        });
      };

      hero.addEventListener('pointermove', (event) => {
        if (!canUsePointerMotion.matches) return;
        const bounds = hero.getBoundingClientRect();
        const x = (event.clientX - bounds.left) / bounds.width - 0.5;
        const y = (event.clientY - bounds.top) / bounds.height - 0.5;

        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (productImage) {
            productImage.style.setProperty('--k9-parallax-x', `${x * 12}px`);
            productImage.style.setProperty('--k9-parallax-y', `${y * 12}px`);
          }
        });
      });

      hero.addEventListener('pointerleave', resetMotion);
      canUsePointerMotion.addEventListener('change', resetMotion);
    }

    if (!product || !rail || rail.dataset.k9RailReady) return;
    rail.dataset.k9RailReady = 'true';

    const nativePrice = product.querySelector('[id^="price-"]');
    const nativeSubmit = product.querySelector('.product-form__submit[name="add"]');
    const railPrice = rail.querySelector('[data-k9-rail-price]');
    const railSubmit = rail.querySelector('[data-k9-rail-submit]');
    const railLabel = rail.querySelector('[data-k9-rail-label]');
    const mobileRail = window.matchMedia('(max-width: 749px)');

    if (!nativeSubmit || !railSubmit) return;

    const syncRail = () => {
      if (nativePrice && railPrice) railPrice.innerHTML = nativePrice.innerHTML;
      railSubmit.disabled = nativeSubmit.disabled || nativeSubmit.getAttribute('aria-disabled') === 'true';
      const nativeLabel = nativeSubmit.querySelector('span');
      if (nativeLabel && railLabel) {
        const label = nativeLabel.textContent.trim();
        railLabel.textContent = !railSubmit.disabled && label === railSubmit.dataset.k9NativeLabel
          ? railSubmit.dataset.k9ButtonLabel
          : label;
      }
    };

    syncRail();
    rail.hidden = false;

    const syncPurchaseRailState = () => {
      const railIsVisible = rail.classList.contains('is-visible');
      const nativeButtonIsVisible = rail.classList.contains('is-native-visible');
      const railStyle = getComputedStyle(rail);
      const height = rail.getBoundingClientRect().height;
      const isVisible = rail.isConnected && !rail.hidden && height > 0 &&
        railStyle.display !== 'none' && railStyle.visibility !== 'hidden' &&
        railIsVisible && (!mobileRail.matches || !nativeButtonIsVisible);
      // Border-box height includes the rail's mobile safe-area padding.
      if (isVisible) document.body.style.setProperty('--k9-sticky-bar-offset', `${height}px`);
      else document.body.style.removeProperty('--k9-sticky-bar-offset');
      document.body.classList.toggle(
        'k9-purchase-rail-visible',
        isVisible
      );
    };

    syncPurchaseRailState();
    const railSizeObserver = new ResizeObserver(syncPurchaseRailState);
    railSizeObserver.observe(rail);
    const railVisibilityObserver = new MutationObserver(syncPurchaseRailState);
    railVisibilityObserver.observe(rail, { attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
    window.addEventListener('resize', syncPurchaseRailState);
    window.addEventListener('orientationchange', syncPurchaseRailState);
    mobileRail.addEventListener('change', syncPurchaseRailState);
    railSubmit.addEventListener('click', () => {
      syncRail();
      if (!railSubmit.disabled) nativeSubmit.click();
    });

    const stateObserver = new MutationObserver(syncRail);
    if (nativePrice) stateObserver.observe(nativePrice, { childList: true, subtree: true, characterData: true });
    stateObserver.observe(nativeSubmit, { attributes: true, childList: true, subtree: true });

    if (hero) {
      const heroObserver = new IntersectionObserver(
        ([entry]) => {
          rail.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom <= 0);
          syncPurchaseRailState();
        },
        { threshold: 0 }
      );
      heroObserver.observe(hero);
    }

    const buttonObserver = new IntersectionObserver(
      ([entry]) => {
        rail.classList.toggle('is-native-visible', entry.isIntersecting);
        syncPurchaseRailState();
      },
      { threshold: 0.5 }
    );
    buttonObserver.observe(nativeSubmit);

    const onSectionUnload = (event) => {
      if (!event.target.contains(rail)) return;
      railSizeObserver.disconnect();
      railVisibilityObserver.disconnect();
      window.removeEventListener('resize', syncPurchaseRailState);
      window.removeEventListener('orientationchange', syncPurchaseRailState);
      mobileRail.removeEventListener('change', syncPurchaseRailState);
      document.body.classList.remove('k9-purchase-rail-visible');
      document.body.style.removeProperty('--k9-sticky-bar-offset');
      document.removeEventListener('shopify:section:unload', onSectionUnload);
    };
    document.addEventListener('shopify:section:unload', onSectionUnload);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initK9Experience);
  } else {
    initK9Experience();
  }

  document.addEventListener('shopify:section:load', initK9Experience);
})();
